module.exports = __webpack_public_path__ + "img/default-img-2.724297d5.jpg";